// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"158":"fb1848a742e1b0e423c0","172":"5482d8e042a4a1d9f726"}[chunkId] + ".css";
};